<div class="user-profile-dialog">
  <div mat-dialog-content>
    <h2 class="dialog-title-row">
      <span>{{ data.title }}</span>
      <button type="button" class="orms-close-button" mat-dialog-close></button>
    </h2>

    <div class="avatar">{{ initials }}</div>

    <div class="email">{{ data.userProfile?.email }}</div>

    <form *ngIf="form" [formGroup]="form" autocomplete="off" (ngSubmit)="save()">
      <mat-form-field appearance="fill">
        <mat-label>{{ 'general.firstName' | translate }}</mat-label>
        <input matInput formControlName="firstName" [placeholder]="'general.typeHere' | translate" />
        <mat-error *ngIf="isFieldInvalid('firstName')">{{ 'general.firstNameRequired' | translate }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>{{ 'general.lastName' | translate }}</mat-label>
        <input matInput formControlName="lastName" [placeholder]="'general.typeHere' | translate" />
        <mat-error *ngIf="isFieldInvalid('lastName')">{{ 'general.lastNameRequired' | translate }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" floatLabel="always" class="phone-form-field">
        <mat-label>{{ 'general.mobilePhone' | translate }}</mat-label>
        <input
          #phoneInput
          matInput
          type="tel"
          formControlName="mobilePhone"
          [placeholder]="'general.typeHere' | translate"
        />
        <mat-error *ngIf="isFieldInvalid('mobilePhone')">{{ phoneErrorMessage }}</mat-error>
      </mat-form-field>
    </form>

    <div class="orms-dialog-footer">
      <div class="orms-dialog-footer-actions">
        <button
          class="orms-button orms-button-primary submit-button"
          type="button"
          [disabled]="isSaving"
          (click)="save()"
        >
          {{ 'general.confirm' | translate }}
        </button>
        <button class="orms-button orms-button-secondary" type="button" mat-dialog-close [disabled]="isSaving">
          {{ data.secondary }}
        </button>
      </div>
      <div class="required-hint"><span>*</span> {{ 'general.fieldIsRequired' | translate }}</div>
    </div>
  </div>
</div>
